var _path, _g, _path2, _path3, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDeliverySelected(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 433,
    height: 55,
    viewBox: "0 0 433 55",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M77.1075 24.248V29H74.7315V16.4H79.6635C80.3115 16.4 80.8755 16.508 81.3555 16.724C81.8355 16.928 82.2315 17.204 82.5435 17.552C82.8675 17.888 83.1075 18.278 83.2635 18.722C83.4315 19.154 83.5155 19.598 83.5155 20.054V20.486C83.5155 20.954 83.4315 21.416 83.2635 21.872C83.1075 22.316 82.8675 22.718 82.5435 23.078C82.2315 23.426 81.8355 23.708 81.3555 23.924C80.8755 24.14 80.3115 24.248 79.6635 24.248H77.1075ZM77.1075 21.98H79.4295C79.9575 21.98 80.3715 21.836 80.6715 21.548C80.9835 21.26 81.1395 20.888 81.1395 20.432V20.216C81.1395 19.76 80.9835 19.388 80.6715 19.1C80.3715 18.812 79.9575 18.668 79.4295 18.668H77.1075V21.98ZM86.023 26.84H89.047V22.232H86.239V20.072H91.315V26.84H93.907V29H86.023V26.84ZM91.873 17.426C91.873 17.666 91.825 17.894 91.729 18.11C91.645 18.314 91.525 18.494 91.369 18.65C91.213 18.794 91.027 18.914 90.811 19.01C90.607 19.094 90.391 19.136 90.163 19.136C89.923 19.136 89.701 19.094 89.497 19.01C89.293 18.914 89.113 18.794 88.957 18.65C88.801 18.494 88.675 18.314 88.579 18.11C88.495 17.894 88.453 17.666 88.453 17.426C88.453 17.186 88.495 16.964 88.579 16.76C88.675 16.544 88.801 16.364 88.957 16.22C89.113 16.064 89.293 15.944 89.497 15.86C89.701 15.764 89.923 15.716 90.163 15.716C90.391 15.716 90.607 15.764 90.811 15.86C91.027 15.944 91.213 16.064 91.369 16.22C91.525 16.364 91.645 16.544 91.729 16.76C91.825 16.964 91.873 17.186 91.873 17.426ZM105.595 25.724C105.391 26.78 104.905 27.632 104.137 28.28C103.381 28.928 102.367 29.252 101.095 29.252C100.435 29.252 99.8165 29.15 99.2405 28.946C98.6765 28.742 98.1845 28.448 97.7645 28.064C97.3445 27.68 97.0145 27.206 96.7745 26.642C96.5345 26.078 96.4145 25.436 96.4145 24.716V24.5C96.4145 23.78 96.5345 23.132 96.7745 22.556C97.0145 21.98 97.3445 21.488 97.7645 21.08C98.1965 20.672 98.6945 20.36 99.2585 20.144C99.8345 19.928 100.447 19.82 101.095 19.82C102.343 19.82 103.351 20.144 104.119 20.792C104.899 21.44 105.391 22.292 105.595 23.348L103.363 23.924C103.291 23.396 103.063 22.94 102.679 22.556C102.295 22.172 101.755 21.98 101.059 21.98C100.735 21.98 100.429 22.04 100.141 22.16C99.8525 22.28 99.6005 22.454 99.3845 22.682C99.1685 22.898 98.9945 23.168 98.8625 23.492C98.7425 23.804 98.6825 24.158 98.6825 24.554V24.662C98.6825 25.058 98.7425 25.412 98.8625 25.724C98.9945 26.024 99.1685 26.276 99.3845 26.48C99.6005 26.684 99.8525 26.84 100.141 26.948C100.429 27.044 100.735 27.092 101.059 27.092C101.755 27.092 102.283 26.918 102.643 26.57C103.015 26.222 103.255 25.754 103.363 25.166L105.595 25.724ZM110.892 23.348H111.324L113.7 20.072H116.184V20.18L113.304 24.266V24.59L116.472 28.892V29H113.88L111.324 25.508H110.892V29H108.624V16.4H110.892V23.348ZM124.973 20.072H127.241V29H124.973V27.704H124.649C124.253 28.736 123.401 29.252 122.093 29.252C121.649 29.252 121.235 29.18 120.851 29.036C120.467 28.892 120.131 28.67 119.843 28.37C119.555 28.07 119.327 27.698 119.159 27.254C119.003 26.798 118.925 26.264 118.925 25.652V20.072H121.193V25.184C121.193 25.82 121.343 26.318 121.643 26.678C121.943 27.026 122.393 27.2 122.993 27.2C123.677 27.2 124.175 26.984 124.487 26.552C124.811 26.108 124.973 25.508 124.973 24.752V20.072ZM131.747 32.6H129.479V20.072H131.747V21.368H132.071C132.311 20.876 132.659 20.498 133.115 20.234C133.571 19.958 134.153 19.82 134.861 19.82C135.389 19.82 135.887 19.922 136.355 20.126C136.835 20.33 137.249 20.63 137.597 21.026C137.957 21.41 138.239 21.884 138.443 22.448C138.659 23.012 138.767 23.654 138.767 24.374V24.698C138.767 25.43 138.665 26.078 138.461 26.642C138.257 27.206 137.981 27.686 137.633 28.082C137.285 28.466 136.871 28.76 136.391 28.964C135.923 29.156 135.413 29.252 134.861 29.252C134.453 29.252 134.099 29.21 133.799 29.126C133.499 29.042 133.235 28.928 133.007 28.784C132.791 28.64 132.605 28.478 132.449 28.298C132.305 28.106 132.179 27.908 132.071 27.704H131.747V32.6ZM134.123 27.092C134.831 27.092 135.401 26.876 135.833 26.444C136.277 26 136.499 25.4 136.499 24.644V24.428C136.499 23.672 136.277 23.078 135.833 22.646C135.401 22.202 134.831 21.98 134.123 21.98C133.415 21.98 132.839 22.208 132.395 22.664C131.963 23.108 131.747 23.696 131.747 24.428V24.644C131.747 25.376 131.963 25.97 132.395 26.426C132.839 26.87 133.415 27.092 134.123 27.092Z",
    fill: "#409BFF"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_173:31490)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1698 3H410.83L411.84 2.99999H412.849V2.10458H411.84H410.83V2H19.1698V2.10458H18.1604H17.1509V2.99999H18.1604L19.1698 3ZM19.1698 45.9797H408.811L409.821 45.9796H410.83V45.0842L411.84 45.0842H412.849V44.1888L413.858 44.1888H414.868V43.2934L415.877 43.2934H416.887V42.398H417.896H418.906V41.5026H417.896H416.887V42.398L415.877 42.398H414.868V43.2934H413.858H412.849V44.1888H411.84H410.83V45.0842H409.821H408.811V44.9797H19.1698V44.1888H18.1604H17.1509V43.2934H16.1415H15.1321V42.398H14.1226L13.1132 42.398V41.5026H12.1038H11.0943V42.398H12.1038H13.1132V43.2934H14.1226L15.1321 43.2934V44.1888H16.1415L17.1509 44.1888V45.0842H18.1604H19.1698V45.9797ZM418.906 40.6072H419.915H420.925V41.5026H419.915H418.906V40.6072ZM421.934 39.7118V40.6072L420.925 40.6072V39.7118H421.934ZM422.943 38.8164V39.7118H421.934V38.8164H422.943ZM423.953 37.921V38.8164L422.943 38.8164V37.921H423.953ZM423.953 37.921V37.0256H424.962V37.921L423.953 37.921ZM425.972 36.1301H424.962V37.0255H425.972V36.1301ZM426.981 35.2347V36.1301L425.972 36.1301V35.2347H426.981ZM427.991 34.3393H426.981V35.2347L427.991 35.2347V34.3393ZM427.991 34.3393H429V33.4439V13.7449V12.8495H427.991V13.7449V33.4439V34.3393ZM11.0943 40.6072H10.0849H9.07547V39.7118H8.06604L8.06604 38.8164H7.0566V37.921H6.04717L6.04717 37.0256H5.03774V37.921L6.04717 37.921V38.8164L7.0566 38.8164V39.7118H8.06604V40.6072L9.07547 40.6072V41.5026H10.0849H11.0943V40.6072ZM4.0283 36.1301H5.03774V37.0255H4.0283V36.1301ZM4.0283 35.2347H3.01887L3.01887 34.3393H2.00943L2.00943 33.4439V13.7449V12.8495H1V13.7449V33.4439V34.3393H2.00943V35.2347L3.01887 35.2347V36.1301H4.0283V35.2347ZM412.849 3.89541H413.858H414.868V4.79081H415.877L416.887 4.79081V5.68622H417.896H418.906V4.79081H417.896H416.887V3.8954H415.877L414.868 3.89541V3H413.858H412.849V3.89541ZM418.906 6.58163H419.915H420.925V7.47704H421.934V6.58163L420.925 6.58163V5.68622H419.915H418.906V6.58163ZM422.943 8.37246H421.934V7.47705H422.943V8.37246ZM423.953 9.26786H422.943V8.37246L423.953 8.37245V9.26786ZM423.953 9.26786L424.962 9.26786V10.1633H423.953V9.26786ZM425.972 11.0587H424.962V10.1633H425.972V11.0587ZM426.981 11.9541H425.972V11.0587L426.981 11.0587V11.9541ZM426.981 11.9541L427.991 11.9541V12.8495H426.981V11.9541ZM17.1509 3.89541H16.1415H15.1321V3H16.1415H17.1509V3.89541ZM13.1132 4.79081V3.8954H14.1226L15.1321 3.89541V4.79081H14.1226L13.1132 4.79081ZM13.1132 4.79081V5.68622H12.1038H11.0943V4.79081H12.1038H13.1132ZM11.0943 6.58163H10.0849H9.07547V5.68622H10.0849H11.0943V6.58163ZM9.07547 6.58163V7.47704H8.06604V6.58163L9.07547 6.58163ZM7.0566 8.37246H8.06604V7.47705H7.0566V8.37246ZM6.04717 9.26786H7.0566V8.37246L6.04717 8.37245V9.26786ZM6.04717 9.26786L6.04717 10.1633H5.03774V9.26786L6.04717 9.26786ZM4.0283 11.0587H5.03774V10.1633H4.0283V11.0587ZM4.0283 11.9541H3.01887V11.0587H4.0283V11.9541ZM3.01887 11.9541L2.00943 11.9541V12.8495H3.01887L3.01887 11.9541Z",
    fill: "#409BFF"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M410.83 3V3.5V3ZM19.1698 3L19.1698 3.5H19.1698V3ZM411.84 2.99999V2.49999V2.99999ZM412.849 2.99999V3.49999H413.349V2.99999H412.849ZM412.849 2.10458H413.349V1.60458H412.849V2.10458ZM410.83 2.10458H410.33V2.60458H410.83V2.10458ZM410.83 2H411.33V1.5H410.83V2ZM19.1698 2V1.5H18.6698V2H19.1698ZM19.1698 2.10458V2.60458H19.6698V2.10458H19.1698ZM17.1509 2.10458V1.60458H16.6509V2.10458H17.1509ZM17.1509 2.99999H16.6509V3.49999H17.1509V2.99999ZM18.1604 2.99999L18.1604 2.49999H18.1604V2.99999ZM408.811 45.9797V46.4797V45.9797ZM19.1698 45.9797H18.6698V46.4797H19.1698V45.9797ZM409.821 45.9796V45.4796V45.9796ZM410.83 45.9796V46.4796H411.33V45.9796H410.83ZM411.84 45.0842V45.5842V45.0842ZM412.849 45.0842V45.5842H413.349V45.0842H412.849ZM413.858 44.1888V44.6888V44.1888ZM414.868 44.1888V44.6888H415.368V44.1888H414.868ZM415.877 43.2934V43.7934V43.2934ZM416.887 43.2934V43.7934H417.387V43.2934H416.887ZM418.906 42.398V42.898H419.406V42.398H418.906ZM418.906 41.5026H419.406V41.0026H418.906V41.5026ZM416.887 41.5026V41.0026H416.387V41.5026H416.887ZM415.877 42.398V41.898V42.398ZM414.868 42.398V41.898H414.368V42.398H414.868ZM412.849 43.2934V42.7934H412.349V43.2934H412.849ZM410.83 44.1888V43.6888H410.33V44.1888H410.83ZM408.811 45.0842H408.311V45.5842H408.811V45.0842ZM408.811 44.9797H409.311V44.4797H408.811V44.9797ZM19.1698 44.9797H18.6698V45.4797H19.1698V44.9797ZM19.1698 44.1888H19.6698V43.6888H19.1698V44.1888ZM17.1509 43.2934H17.6509V42.7934H17.1509V43.2934ZM15.1321 42.398H15.6321V41.898H15.1321V42.398ZM14.1226 42.398V41.898H14.1226L14.1226 42.398ZM13.1132 41.5026H13.6132V41.0026H13.1132V41.5026ZM11.0943 41.5026V41.0026H10.5943V41.5026H11.0943ZM11.0943 42.398H10.5943V42.898H11.0943V42.398ZM13.1132 43.2934H12.6132V43.7934H13.1132V43.2934ZM14.1226 43.2934V43.7934H14.1226L14.1226 43.2934ZM15.1321 44.1888H14.6321V44.6888H15.1321V44.1888ZM16.1415 44.1888V44.6888H16.1415L16.1415 44.1888ZM17.1509 45.0842H16.6509V45.5842H17.1509V45.0842ZM19.1698 45.0842H19.6698V44.5842H19.1698V45.0842ZM418.906 40.6072V40.1072H418.406V40.6072H418.906ZM420.925 41.5026V42.0026H421.425V41.5026H420.925ZM418.906 41.5026H418.406V42.0026H418.906V41.5026ZM421.934 40.6072V41.1072H422.434V40.6072H421.934ZM420.925 39.7118V39.2118H420.425V39.7118H420.925ZM422.943 39.7118V40.2118H423.443V39.7118H422.943ZM421.934 38.8164V38.3164H421.434V38.8164H421.934ZM423.953 38.8164V39.3164H424.453V38.8164H423.953ZM422.943 37.921V37.421H422.443V37.921H422.943ZM423.953 37.0256V36.5256H423.453V37.0256H423.953ZM424.962 37.0256H425.462V36.5256H424.962V37.0256ZM424.962 37.921V38.421H425.462V37.921H424.962ZM424.962 36.1301V35.6301H424.462V36.1301H424.962ZM424.962 37.0255H424.462V37.5255H424.962V37.0255ZM425.972 37.0255V37.5255H426.472V37.0255H425.972ZM426.981 36.1301V36.6301H427.481V36.1301H426.981ZM425.972 35.2347V34.7347H425.472V35.2347H425.972ZM426.981 34.3393V33.8393H426.481V34.3393H426.981ZM427.991 35.2347V35.7347H428.491V35.2347H427.991ZM429 34.3393V34.8393H429.5V34.3393H429ZM429 12.8495H429.5V12.3495H429V12.8495ZM427.991 12.8495V12.3495H427.491V12.8495H427.991ZM11.0943 40.6072H11.5943V40.1072H11.0943V40.6072ZM9.07547 39.7118H9.57547V39.2118H9.07547V39.7118ZM8.06604 38.8164H8.56604L8.56604 38.3164H8.06604V38.8164ZM7.0566 37.921H7.5566V37.421H7.0566V37.921ZM6.04717 37.0256H6.54717L6.54717 36.5256H6.04717V37.0256ZM5.03774 37.0256V36.5256H4.53774V37.0256H5.03774ZM5.03774 37.921H4.53774V38.421H5.03774L5.03774 37.921ZM6.04717 38.8164H5.54717V39.3164H6.04717L6.04717 38.8164ZM7.0566 39.7118H6.5566V40.2118H7.0566V39.7118ZM8.06604 40.6072H7.56604V41.1072H8.06604L8.06604 40.6072ZM9.07547 41.5026H8.57547V42.0026H9.07547V41.5026ZM11.0943 41.5026V42.0026H11.5943V41.5026H11.0943ZM5.03774 36.1301H5.53774V35.6301H5.03774V36.1301ZM4.0283 36.1301V35.6301H3.5283V36.1301H4.0283ZM5.03774 37.0255V37.5255H5.53774V37.0255H5.03774ZM4.0283 37.0255H3.5283V37.5255H4.0283V37.0255ZM4.0283 35.2347H4.5283V34.7347H4.0283V35.2347ZM3.01887 34.3393H3.51887L3.51887 33.8393H3.01887V34.3393ZM2.00943 33.4439H2.50943H2.00943ZM2.00943 12.8495H2.50943V12.3495H2.00943V12.8495ZM1 12.8495V12.3495H0.5V12.8495H1ZM1 34.3393H0.5V34.8393H1V34.3393ZM2.00943 35.2347H1.50943V35.7347H2.00944L2.00943 35.2347ZM3.01887 36.1301H2.51887V36.6301H3.01887V36.1301ZM4.0283 36.1301V36.6301H4.5283V36.1301H4.0283ZM412.849 3.89541H412.349V4.39541H412.849V3.89541ZM414.868 4.79081H414.368V5.29081H414.868V4.79081ZM415.877 4.79081V5.29081V4.79081ZM416.887 5.68622H416.387V6.18622H416.887V5.68622ZM418.906 5.68622V6.18622H419.406V5.68622H418.906ZM418.906 4.79081H419.406V4.29081H418.906V4.79081ZM416.887 3.8954H417.387V3.3954H416.887V3.8954ZM415.877 3.8954V3.3954V3.8954ZM414.868 3H415.368V2.5H414.868V3ZM412.849 3V2.5H412.349V3H412.849ZM418.906 6.58163H418.406V7.08163H418.906V6.58163ZM420.925 7.47704H420.425V7.97704H420.925V7.47704ZM421.934 7.47704V7.97704H422.434V7.47704H421.934ZM421.934 6.58163H422.434V6.08163L421.934 6.08163V6.58163ZM420.925 5.68622H421.425V5.18622H420.925V5.68622ZM418.906 5.68622V5.18622H418.406V5.68622H418.906ZM421.934 8.37246H421.434V8.87246H421.934V8.37246ZM421.934 7.47705V6.97705H421.434V7.47705H421.934ZM422.943 7.47705H423.443V6.97705H422.943V7.47705ZM422.943 9.26786H422.443V9.76786H422.943V9.26786ZM423.953 8.37245H424.453V7.87245L423.953 7.87245V8.37245ZM424.962 9.26786H425.462V8.76786L424.962 8.76786V9.26786ZM424.962 10.1633V10.6633H425.462V10.1633H424.962ZM423.953 10.1633H423.453V10.6633H423.953V10.1633ZM424.962 11.0587H424.462V11.5587H424.962V11.0587ZM424.962 10.1633V9.66327H424.462V10.1633H424.962ZM425.972 10.1633H426.472V9.66327H425.972V10.1633ZM425.972 11.9541H425.472V12.4541H425.972V11.9541ZM426.981 11.0587H427.481V10.5587L426.981 10.5587V11.0587ZM427.991 11.9541H428.491V11.4541L427.991 11.4541V11.9541ZM427.991 12.8495V13.3495H428.491V12.8495H427.991ZM426.981 12.8495H426.481V13.3495H426.981V12.8495ZM17.1509 3.89541V4.39541H17.6509V3.89541H17.1509ZM15.1321 3V2.5H14.6321V3H15.1321ZM17.1509 3H17.6509V2.5H17.1509V3ZM13.1132 3.8954V3.3954H12.6132V3.8954H13.1132ZM14.1226 3.8954L14.1226 3.3954H14.1226V3.8954ZM15.1321 4.79081V5.29081H15.6321V4.79081H15.1321ZM14.1226 4.79081L14.1226 5.29081H14.1226V4.79081ZM13.1132 5.68622V6.18622H13.6132V5.68622H13.1132ZM11.0943 5.68622H10.5943V6.18622H11.0943V5.68622ZM11.0943 4.79081V4.29081H10.5943V4.79081H11.0943ZM11.0943 6.58163V7.08163H11.5943V6.58163H11.0943ZM9.07547 5.68622V5.18622H8.57547V5.68622H9.07547ZM11.0943 5.68622H11.5943V5.18622H11.0943V5.68622ZM9.07547 7.47704V7.97704H9.57547V7.47704H9.07547ZM8.06604 7.47704H7.56604V7.97704H8.06604V7.47704ZM8.06604 6.58163L8.06604 6.08163L7.56604 6.08163V6.58163H8.06604ZM8.06604 8.37246V8.87246H8.56604V8.37246H8.06604ZM8.06604 7.47705H8.56604V6.97705H8.06604V7.47705ZM7.0566 7.47705V6.97705H6.5566V7.47705H7.0566ZM7.0566 9.26786V9.76786H7.5566V9.26786H7.0566ZM6.04717 8.37245L6.04717 7.87245L5.54717 7.87245V8.37245H6.04717ZM6.04717 10.1633V10.6633H6.54717L6.54717 10.1633H6.04717ZM5.03774 10.1633H4.53774V10.6633H5.03774V10.1633ZM5.03774 9.26786L5.03774 8.76786L4.53774 8.76786V9.26786H5.03774ZM5.03774 11.0587V11.5587H5.53774V11.0587H5.03774ZM4.0283 11.0587H3.5283V11.5587H4.0283V11.0587ZM5.03774 10.1633H5.53774V9.66327H5.03774V10.1633ZM4.0283 10.1633V9.66327H3.5283V10.1633H4.0283ZM4.0283 11.9541V12.4541H4.5283V11.9541H4.0283ZM3.01887 11.0587V10.5587H2.51887V11.0587H3.01887ZM4.0283 11.0587H4.5283V10.5587H4.0283V11.0587ZM2.00943 11.9541L2.00944 11.4541L1.50943 11.4541V11.9541H2.00943ZM2.00943 12.8495H1.50943V13.3495H2.00943V12.8495ZM3.01887 12.8495V13.3495H3.51887L3.51887 12.8495H3.01887ZM410.83 2.5H19.1698V3.5H410.83V2.5ZM411.84 2.49999L410.83 2.5V3.5L411.84 3.49999V2.49999ZM412.849 2.49999H411.84V3.49999H412.849V2.49999ZM412.349 2.10458V2.99999H413.349V2.10458H412.349ZM411.84 2.60458H412.849V1.60458H411.84V2.60458ZM410.83 2.60458H411.84V1.60458H410.83V2.60458ZM410.33 2V2.10458H411.33V2H410.33ZM19.1698 2.5H410.83V1.5H19.1698V2.5ZM19.6698 2.10458V2H18.6698V2.10458H19.6698ZM18.1604 2.60458H19.1698V1.60458H18.1604V2.60458ZM17.1509 2.60458H18.1604V1.60458H17.1509V2.60458ZM17.6509 2.99999V2.10458H16.6509V2.99999H17.6509ZM18.1604 2.49999H17.1509V3.49999H18.1604V2.49999ZM19.1698 2.5L18.1604 2.49999L18.1604 3.49999L19.1698 3.5L19.1698 2.5ZM408.811 45.4797H19.1698V46.4797H408.811V45.4797ZM409.821 45.4796L408.811 45.4797V46.4797L409.821 46.4796V45.4796ZM410.83 45.4796H409.821V46.4796H410.83V45.4796ZM410.33 45.0842V45.9796H411.33V45.0842H410.33ZM411.84 44.5842L410.83 44.5842V45.5842L411.84 45.5842V44.5842ZM412.849 44.5842H411.84V45.5842H412.849V44.5842ZM412.349 44.1888V45.0842H413.349V44.1888H412.349ZM413.858 43.6888L412.849 43.6888V44.6888L413.858 44.6888V43.6888ZM414.868 43.6888H413.858V44.6888H414.868V43.6888ZM414.368 43.2934V44.1888H415.368V43.2934H414.368ZM415.877 42.7934L414.868 42.7934V43.7934L415.877 43.7934V42.7934ZM416.887 42.7934H415.877V43.7934H416.887V42.7934ZM416.387 42.398V43.2934H417.387V42.398H416.387ZM417.896 41.898H416.887V42.898H417.896V41.898ZM418.906 41.898H417.896V42.898H418.906V41.898ZM418.406 41.5026V42.398H419.406V41.5026H418.406ZM417.896 42.0026H418.906V41.0026H417.896V42.0026ZM416.887 42.0026H417.896V41.0026H416.887V42.0026ZM417.387 42.398V41.5026H416.387V42.398H417.387ZM415.877 42.898L416.887 42.898V41.898L415.877 41.898V42.898ZM414.868 42.898H415.877V41.898H414.868V42.898ZM415.368 43.2934V42.398H414.368V43.2934H415.368ZM413.858 43.7934H414.868V42.7934H413.858V43.7934ZM412.849 43.7934H413.858V42.7934H412.849V43.7934ZM413.349 44.1888V43.2934H412.349V44.1888H413.349ZM411.84 44.6888H412.849V43.6888H411.84V44.6888ZM410.83 44.6888H411.84V43.6888H410.83V44.6888ZM411.33 45.0842V44.1888H410.33V45.0842H411.33ZM409.821 45.5842H410.83V44.5842H409.821V45.5842ZM408.811 45.5842H409.821V44.5842H408.811V45.5842ZM408.311 44.9797V45.0842H409.311V44.9797H408.311ZM19.1698 45.4797H408.811V44.4797H19.1698V45.4797ZM18.6698 44.1888V44.9797H19.6698V44.1888H18.6698ZM18.1604 44.6888H19.1698V43.6888H18.1604V44.6888ZM17.1509 44.6888H18.1604V43.6888H17.1509V44.6888ZM16.6509 43.2934V44.1888H17.6509V43.2934H16.6509ZM16.1415 43.7934H17.1509V42.7934H16.1415V43.7934ZM15.1321 43.7934H16.1415V42.7934H15.1321V43.7934ZM14.6321 42.398V43.2934H15.6321V42.398H14.6321ZM14.1226 42.898H15.1321V41.898H14.1226V42.898ZM13.1132 42.898L14.1226 42.898L14.1226 41.898L13.1132 41.898L13.1132 42.898ZM12.6132 41.5026V42.398H13.6132V41.5026H12.6132ZM12.1038 42.0026H13.1132V41.0026H12.1038V42.0026ZM11.0943 42.0026H12.1038V41.0026H11.0943V42.0026ZM11.5943 42.398V41.5026H10.5943V42.398H11.5943ZM12.1038 41.898H11.0943V42.898H12.1038V41.898ZM13.1132 41.898H12.1038V42.898H13.1132V41.898ZM13.6132 43.2934V42.398H12.6132V43.2934H13.6132ZM14.1226 42.7934H13.1132V43.7934H14.1226V42.7934ZM15.1321 42.7934L14.1226 42.7934L14.1226 43.7934L15.1321 43.7934L15.1321 42.7934ZM15.6321 44.1888V43.2934H14.6321V44.1888H15.6321ZM16.1415 43.6888H15.1321V44.6888H16.1415V43.6888ZM17.1509 43.6888L16.1415 43.6888L16.1415 44.6888L17.1509 44.6888L17.1509 43.6888ZM17.6509 45.0842V44.1888H16.6509V45.0842H17.6509ZM18.1604 44.5842H17.1509V45.5842H18.1604V44.5842ZM19.1698 44.5842H18.1604V45.5842H19.1698V44.5842ZM19.6698 45.9797V45.0842H18.6698V45.9797H19.6698ZM419.915 40.1072H418.906V41.1072H419.915V40.1072ZM420.925 40.1072H419.915V41.1072H420.925V40.1072ZM421.425 41.5026V40.6072H420.425V41.5026H421.425ZM419.915 42.0026H420.925V41.0026H419.915V42.0026ZM418.906 42.0026H419.915V41.0026H418.906V42.0026ZM418.406 40.6072V41.5026H419.406V40.6072H418.406ZM422.434 40.6072V39.7118H421.434V40.6072H422.434ZM420.925 41.1072L421.934 41.1072V40.1072L420.925 40.1072V41.1072ZM420.425 39.7118V40.6072H421.425V39.7118H420.425ZM421.934 39.2118H420.925V40.2118H421.934V39.2118ZM423.443 39.7118V38.8164H422.443V39.7118H423.443ZM421.934 40.2118H422.943V39.2118H421.934V40.2118ZM421.434 38.8164V39.7118H422.434V38.8164H421.434ZM422.943 38.3164H421.934V39.3164H422.943V38.3164ZM424.453 38.8164V37.921H423.453V38.8164H424.453ZM422.943 39.3164L423.953 39.3164V38.3164L422.943 38.3164V39.3164ZM422.443 37.921V38.8164H423.443V37.921H422.443ZM423.953 37.421H422.943V38.421H423.953V37.421ZM423.453 37.0256V37.921H424.453V37.0256H423.453ZM424.962 36.5256H423.953V37.5256H424.962V36.5256ZM425.462 37.921V37.0256H424.462V37.921H425.462ZM423.953 38.421L424.962 38.421V37.421L423.953 37.421V38.421ZM424.962 36.6301H425.972V35.6301H424.962V36.6301ZM425.462 37.0255V36.1301H424.462V37.0255H425.462ZM425.972 36.5255H424.962V37.5255H425.972V36.5255ZM425.472 36.1301V37.0255H426.472V36.1301H425.472ZM427.481 36.1301V35.2347H426.481V36.1301H427.481ZM425.972 36.6301L426.981 36.6301V35.6301L425.972 35.6301V36.6301ZM425.472 35.2347V36.1301H426.472V35.2347H425.472ZM426.981 34.7347H425.972V35.7347H426.981V34.7347ZM426.981 34.8393H427.991V33.8393H426.981V34.8393ZM427.481 35.2347V34.3393H426.481V35.2347H427.481ZM427.991 34.7347L426.981 34.7347V35.7347L427.991 35.7347V34.7347ZM427.491 34.3393V35.2347H428.491V34.3393H427.491ZM427.991 34.8393H429V33.8393H427.991V34.8393ZM429.5 34.3393V33.4439H428.5V34.3393H429.5ZM429.5 33.4439V13.7449H428.5V33.4439H429.5ZM429.5 13.7449V12.8495H428.5V13.7449H429.5ZM429 12.3495H427.991V13.3495H429V12.3495ZM427.491 12.8495V13.7449H428.491V12.8495H427.491ZM427.491 13.7449V33.4439H428.491V13.7449H427.491ZM427.491 33.4439V34.3393H428.491V33.4439H427.491ZM10.0849 41.1072H11.0943V40.1072H10.0849V41.1072ZM9.07547 41.1072H10.0849V40.1072H9.07547V41.1072ZM8.57547 39.7118V40.6072H9.57547V39.7118H8.57547ZM8.06604 40.2118H9.07547V39.2118H8.06604V40.2118ZM7.56604 38.8164L7.56604 39.7118H8.56604L8.56604 38.8164H7.56604ZM7.0566 39.3164H8.06604V38.3164H7.0566V39.3164ZM6.5566 37.921V38.8164H7.5566V37.921H6.5566ZM6.04717 38.421H7.0566V37.421H6.04717V38.421ZM5.54717 37.0256L5.54717 37.921H6.54717L6.54717 37.0256H5.54717ZM5.03774 37.5256H6.04717V36.5256H5.03774V37.5256ZM5.53774 37.921V37.0256H4.53774V37.921H5.53774ZM6.04717 37.421L5.03773 37.421L5.03774 38.421L6.04717 38.421L6.04717 37.421ZM6.54717 38.8164V37.921H5.54717V38.8164H6.54717ZM7.0566 38.3164L6.04717 38.3164L6.04717 39.3164L7.05661 39.3164L7.0566 38.3164ZM7.5566 39.7118V38.8164H6.5566V39.7118H7.5566ZM8.06604 39.2118H7.0566V40.2118H8.06604V39.2118ZM8.56604 40.6072V39.7118H7.56604V40.6072H8.56604ZM9.07547 40.1072L8.06604 40.1072L8.06604 41.1072L9.07547 41.1072L9.07547 40.1072ZM9.57547 41.5026V40.6072H8.57547V41.5026H9.57547ZM10.0849 41.0026H9.07547V42.0026H10.0849V41.0026ZM11.0943 41.0026H10.0849V42.0026H11.0943V41.0026ZM10.5943 40.6072V41.5026H11.5943V40.6072H10.5943ZM5.03774 35.6301H4.0283V36.6301H5.03774V35.6301ZM5.53774 37.0255V36.1301H4.53774V37.0255H5.53774ZM4.0283 37.5255H5.03774V36.5255H4.0283V37.5255ZM3.5283 36.1301V37.0255H4.5283V36.1301H3.5283ZM3.01887 35.7347H4.0283V34.7347H3.01887V35.7347ZM2.51887 34.3393L2.51887 35.2347H3.51887L3.51887 34.3393H2.51887ZM2.00943 34.8393H3.01887V33.8393H2.00943V34.8393ZM1.50943 33.4439L1.50943 34.3393H2.50943L2.50943 33.4439H1.50943ZM2.50943 33.4439V13.7449H1.50943V33.4439H2.50943ZM2.50943 13.7449V12.8495H1.50943V13.7449H2.50943ZM2.00943 12.3495H1V13.3495H2.00943V12.3495ZM0.5 12.8495V13.7449H1.5V12.8495H0.5ZM0.5 13.7449V33.4439H1.5V13.7449H0.5ZM1.5 34.3393V33.4439H0.5V34.3393H1.5ZM2.00943 33.8393H1V34.8393H2.00943V33.8393ZM2.50943 35.2347V34.3393H1.50943V35.2347H2.50943ZM3.01887 34.7347L2.00943 34.7347L2.00944 35.7347L3.01887 35.7347L3.01887 34.7347ZM3.51887 36.1301V35.2347H2.51887V36.1301H3.51887ZM4.0283 35.6301H3.01887V36.6301H4.0283V35.6301ZM3.5283 35.2347V36.1301H4.5283V35.2347H3.5283ZM413.858 3.39541H412.849V4.39541H413.858V3.39541ZM414.868 3.39541H413.858V4.39541H414.868V3.39541ZM415.368 4.79081V3.89541H414.368V4.79081H415.368ZM415.877 4.29081H414.868V5.29081H415.877V4.29081ZM416.887 4.29081L415.877 4.29081V5.29081L416.887 5.29081V4.29081ZM417.387 5.68622V4.79081H416.387V5.68622H417.387ZM417.896 5.18622H416.887V6.18622H417.896V5.18622ZM418.906 5.18622H417.896V6.18622H418.906V5.18622ZM418.406 4.79081V5.68622H419.406V4.79081H418.406ZM417.896 5.29081H418.906V4.29081H417.896V5.29081ZM416.887 5.29081H417.896V4.29081H416.887V5.29081ZM416.387 3.8954V4.79081H417.387V3.8954H416.387ZM415.877 4.3954H416.887V3.3954H415.877V4.3954ZM414.868 4.39541L415.877 4.3954V3.3954L414.868 3.39541V4.39541ZM414.368 3V3.89541H415.368V3H414.368ZM413.858 3.5H414.868V2.5H413.858V3.5ZM412.849 3.5H413.858V2.5H412.849V3.5ZM413.349 3.89541V3H412.349V3.89541H413.349ZM419.915 6.08163H418.906V7.08163H419.915V6.08163ZM420.925 6.08163H419.915V7.08163H420.925V6.08163ZM421.425 7.47704V6.58163H420.425V7.47704H421.425ZM421.934 6.97704H420.925V7.97704H421.934V6.97704ZM421.434 6.58163V7.47704H422.434V6.58163H421.434ZM420.925 7.08163L421.934 7.08163V6.08163L420.925 6.08163V7.08163ZM420.425 5.68622V6.58163H421.425V5.68622H420.425ZM419.915 6.18622H420.925V5.18622H419.915V6.18622ZM418.906 6.18622H419.915V5.18622H418.906V6.18622ZM419.406 6.58163V5.68622H418.406V6.58163H419.406ZM421.934 8.87246H422.943V7.87246H421.934V8.87246ZM421.434 7.47705V8.37246H422.434V7.47705H421.434ZM422.943 6.97705H421.934V7.97705H422.943V6.97705ZM423.443 8.37246V7.47705H422.443V8.37246H423.443ZM422.943 9.76786H423.953V8.76786H422.943V9.76786ZM422.443 8.37246V9.26786H423.443V8.37246H422.443ZM423.953 7.87245L422.943 7.87246V8.87246L423.953 8.87245V7.87245ZM424.453 9.26786V8.37245H423.453V9.26786H424.453ZM424.962 8.76786L423.953 8.76786V9.76786L424.962 9.76786V8.76786ZM425.462 10.1633V9.26786H424.462V10.1633H425.462ZM423.953 10.6633H424.962V9.66327H423.953V10.6633ZM423.453 9.26786V10.1633H424.453V9.26786H423.453ZM424.962 11.5587H425.972V10.5587H424.962V11.5587ZM424.462 10.1633V11.0587H425.462V10.1633H424.462ZM425.972 9.66327H424.962V10.6633H425.972V9.66327ZM426.472 11.0587V10.1633H425.472V11.0587H426.472ZM425.972 12.4541H426.981V11.4541H425.972V12.4541ZM425.472 11.0587V11.9541H426.472V11.0587H425.472ZM426.981 10.5587L425.972 10.5587V11.5587L426.981 11.5587V10.5587ZM427.481 11.9541V11.0587H426.481V11.9541H427.481ZM427.991 11.4541L426.981 11.4541V12.4541L427.991 12.4541V11.4541ZM428.491 12.8495V11.9541H427.491V12.8495H428.491ZM426.981 13.3495H427.991V12.3495H426.981V13.3495ZM426.481 11.9541V12.8495H427.481V11.9541H426.481ZM16.1415 4.39541H17.1509V3.39541H16.1415V4.39541ZM15.1321 4.39541H16.1415V3.39541H15.1321V4.39541ZM14.6321 3V3.89541H15.6321V3H14.6321ZM16.1415 2.5H15.1321V3.5H16.1415V2.5ZM17.1509 2.5H16.1415V3.5H17.1509V2.5ZM17.6509 3.89541V3H16.6509V3.89541H17.6509ZM12.6132 3.8954V4.79081H13.6132V3.8954H12.6132ZM14.1226 3.3954H13.1132V4.3954H14.1226V3.3954ZM15.1321 3.39541L14.1226 3.3954L14.1226 4.3954L15.1321 4.39541L15.1321 3.39541ZM15.6321 4.79081V3.89541H14.6321V4.79081H15.6321ZM14.1226 5.29081H15.1321V4.29081H14.1226V5.29081ZM13.1132 5.29081L14.1226 5.29081L14.1226 4.29081L13.1132 4.29081L13.1132 5.29081ZM13.6132 5.68622V4.79081H12.6132V5.68622H13.6132ZM12.1038 6.18622H13.1132V5.18622H12.1038V6.18622ZM11.0943 6.18622H12.1038V5.18622H11.0943V6.18622ZM10.5943 4.79081V5.68622H11.5943V4.79081H10.5943ZM12.1038 4.29081H11.0943V5.29081H12.1038V4.29081ZM13.1132 4.29081H12.1038V5.29081H13.1132V4.29081ZM10.0849 7.08163H11.0943V6.08163H10.0849V7.08163ZM9.07547 7.08163H10.0849V6.08163H9.07547V7.08163ZM8.57547 5.68622V6.58163H9.57547V5.68622H8.57547ZM10.0849 5.18622H9.07547V6.18622H10.0849V5.18622ZM11.0943 5.18622H10.0849V6.18622H11.0943V5.18622ZM11.5943 6.58163V5.68622H10.5943V6.58163H11.5943ZM9.57547 7.47704V6.58163H8.57547V7.47704H9.57547ZM8.06604 7.97704H9.07547V6.97704H8.06604V7.97704ZM7.56604 6.58163V7.47704H8.56604V6.58163H7.56604ZM9.07547 6.08163L8.06604 6.08163L8.06604 7.08163L9.07547 7.08163L9.07547 6.08163ZM8.06604 7.87246H7.0566V8.87246H8.06604V7.87246ZM7.56604 7.47705V8.37246H8.56604V7.47705H7.56604ZM7.0566 7.97705H8.06604V6.97705H7.0566V7.97705ZM7.5566 8.37246V7.47705H6.5566V8.37246H7.5566ZM7.0566 8.76786H6.04717V9.76786H7.0566V8.76786ZM6.5566 8.37246V9.26786H7.5566V8.37246H6.5566ZM6.04717 8.87245L7.0566 8.87246L7.05661 7.87246L6.04717 7.87245L6.04717 8.87245ZM6.54717 9.26786V8.37245H5.54717V9.26786H6.54717ZM6.54717 10.1633L6.54717 9.26786L5.54717 9.26786L5.54717 10.1633H6.54717ZM5.03774 10.6633H6.04717V9.66327H5.03774V10.6633ZM4.53774 9.26786V10.1633H5.53774V9.26786H4.53774ZM6.04717 8.76786L5.03774 8.76786L5.03773 9.76786L6.04717 9.76786L6.04717 8.76786ZM5.03774 10.5587H4.0283V11.5587H5.03774V10.5587ZM4.53774 10.1633V11.0587H5.53774V10.1633H4.53774ZM4.0283 10.6633H5.03774V9.66327H4.0283V10.6633ZM4.5283 11.0587V10.1633H3.5283V11.0587H4.5283ZM3.01887 12.4541H4.0283V11.4541H3.01887V12.4541ZM2.51887 11.0587V11.9541H3.51887V11.0587H2.51887ZM4.0283 10.5587H3.01887V11.5587H4.0283V10.5587ZM4.5283 11.9541V11.0587H3.5283V11.9541H4.5283ZM2.00943 12.4541L3.01887 12.4541L3.01887 11.4541L2.00944 11.4541L2.00943 12.4541ZM2.50943 12.8495V11.9541H1.50943V12.8495H2.50943ZM3.01887 12.3495H2.00943V13.3495H3.01887V12.3495ZM2.51887 11.9541L2.51887 12.8495H3.51887L3.51887 11.9541H2.51887Z",
    fill: "#409BFF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M279.808 16.4H284.38C285.94 16.4 287.098 16.766 287.854 17.498C288.61 18.218 288.988 19.34 288.988 20.864V24.536C288.988 26.06 288.61 27.188 287.854 27.92C287.098 28.64 285.94 29 284.38 29H279.808V26.714H280.996V18.668H279.808V16.4ZM284.38 26.732C285.208 26.732 285.784 26.54 286.108 26.156C286.444 25.76 286.612 25.148 286.612 24.32V20.864C286.612 20.144 286.444 19.598 286.108 19.226C285.784 18.854 285.208 18.668 284.38 18.668H283.372V26.732H284.38ZM293.404 25.274C293.416 25.538 293.476 25.784 293.584 26.012C293.704 26.228 293.86 26.42 294.052 26.588C294.256 26.744 294.484 26.87 294.736 26.966C295 27.05 295.276 27.092 295.564 27.092C296.128 27.092 296.56 26.996 296.86 26.804C297.16 26.6 297.376 26.36 297.508 26.084L299.452 27.164C299.344 27.392 299.194 27.632 299.002 27.884C298.81 28.124 298.558 28.346 298.246 28.55C297.946 28.754 297.574 28.922 297.13 29.054C296.698 29.186 296.188 29.252 295.6 29.252C294.928 29.252 294.316 29.144 293.764 28.928C293.212 28.712 292.732 28.4 292.324 27.992C291.928 27.584 291.616 27.086 291.388 26.498C291.172 25.91 291.064 25.244 291.064 24.5V24.392C291.064 23.708 291.178 23.084 291.406 22.52C291.646 21.956 291.97 21.476 292.378 21.08C292.786 20.684 293.26 20.378 293.8 20.162C294.352 19.934 294.94 19.82 295.564 19.82C296.332 19.82 296.992 19.958 297.544 20.234C298.096 20.498 298.552 20.84 298.912 21.26C299.272 21.668 299.536 22.124 299.704 22.628C299.872 23.12 299.956 23.6 299.956 24.068V25.274H293.404ZM295.546 21.872C294.97 21.872 294.502 22.022 294.142 22.322C293.782 22.61 293.548 22.946 293.44 23.33H297.652C297.58 22.91 297.352 22.562 296.968 22.286C296.596 22.01 296.122 21.872 295.546 21.872ZM302.373 26.84H305.505V18.56H302.481V16.4H307.773V26.84H310.689V29H302.373V26.84ZM313.611 26.84H316.635V22.232H313.827V20.072H318.903V26.84H321.495V29H313.611V26.84ZM319.461 17.426C319.461 17.666 319.413 17.894 319.317 18.11C319.233 18.314 319.113 18.494 318.957 18.65C318.801 18.794 318.615 18.914 318.399 19.01C318.195 19.094 317.979 19.136 317.751 19.136C317.511 19.136 317.289 19.094 317.085 19.01C316.881 18.914 316.701 18.794 316.545 18.65C316.389 18.494 316.263 18.314 316.167 18.11C316.083 17.894 316.041 17.666 316.041 17.426C316.041 17.186 316.083 16.964 316.167 16.76C316.263 16.544 316.389 16.364 316.545 16.22C316.701 16.064 316.881 15.944 317.085 15.86C317.289 15.764 317.511 15.716 317.751 15.716C317.979 15.716 318.195 15.764 318.399 15.86C318.615 15.944 318.801 16.064 318.957 16.22C319.113 16.364 319.233 16.544 319.317 16.76C319.413 16.964 319.461 17.186 319.461 17.426ZM323.84 20.072H326.288L328.394 27.92H328.718L330.824 20.072H333.272L330.716 29H326.396L323.84 20.072ZM337.49 25.274C337.502 25.538 337.562 25.784 337.67 26.012C337.79 26.228 337.946 26.42 338.138 26.588C338.342 26.744 338.57 26.87 338.822 26.966C339.086 27.05 339.362 27.092 339.65 27.092C340.214 27.092 340.646 26.996 340.946 26.804C341.246 26.6 341.462 26.36 341.594 26.084L343.538 27.164C343.43 27.392 343.28 27.632 343.088 27.884C342.896 28.124 342.644 28.346 342.332 28.55C342.032 28.754 341.66 28.922 341.216 29.054C340.784 29.186 340.274 29.252 339.686 29.252C339.014 29.252 338.402 29.144 337.85 28.928C337.298 28.712 336.818 28.4 336.41 27.992C336.014 27.584 335.702 27.086 335.474 26.498C335.258 25.91 335.15 25.244 335.15 24.5V24.392C335.15 23.708 335.264 23.084 335.492 22.52C335.732 21.956 336.056 21.476 336.464 21.08C336.872 20.684 337.346 20.378 337.886 20.162C338.438 19.934 339.026 19.82 339.65 19.82C340.418 19.82 341.078 19.958 341.63 20.234C342.182 20.498 342.638 20.84 342.998 21.26C343.358 21.668 343.622 22.124 343.79 22.628C343.958 23.12 344.042 23.6 344.042 24.068V25.274H337.49ZM339.632 21.872C339.056 21.872 338.588 22.022 338.228 22.322C337.868 22.61 337.634 22.946 337.526 23.33H341.738C341.666 22.91 341.438 22.562 341.054 22.286C340.682 22.01 340.208 21.872 339.632 21.872ZM346.081 20.072H349.861V21.368H350.185C350.353 20.876 350.635 20.498 351.031 20.234C351.439 19.958 351.925 19.82 352.489 19.82C353.377 19.82 354.091 20.102 354.631 20.666C355.171 21.218 355.441 22.064 355.441 23.204V23.6L353.101 23.816V23.564C353.101 23.072 352.975 22.682 352.723 22.394C352.471 22.094 352.093 21.944 351.589 21.944C351.085 21.944 350.689 22.118 350.401 22.466C350.113 22.814 349.969 23.312 349.969 23.96V26.84H352.021V29H345.865V26.84H347.701V22.232H346.081V20.072ZM363.582 20.072H365.85V31.196C365.85 31.604 365.718 31.94 365.454 32.204C365.202 32.468 364.872 32.6 364.464 32.6H359.154V30.44H363.096C363.42 30.44 363.582 30.26 363.582 29.9V27.704H363.258C362.862 28.736 362.01 29.252 360.702 29.252C360.258 29.252 359.844 29.18 359.46 29.036C359.076 28.892 358.74 28.67 358.452 28.37C358.164 28.07 357.936 27.698 357.768 27.254C357.612 26.798 357.534 26.264 357.534 25.652V20.072H359.802V25.184C359.802 25.82 359.952 26.318 360.252 26.678C360.552 27.026 361.002 27.2 361.602 27.2C362.286 27.2 362.784 26.984 363.096 26.552C363.42 26.108 363.582 25.508 363.582 24.752V20.072Z",
    fill: "#409BFF"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_173:31490)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M236 0H234V1.09524H232V2.19047H230V3.28571H228V4.38095H226V5.47619H225V6.57143H224V7.66667H223V8.76191H222V9.85714H221H220.5H220V10.9524H219.5H219V36.1429H219.5H220V37.2381H220.5H221H222V38.3333H223V39.4286H224V40.5238H225V41.619H226V42.7143H228V43.8095H230V44.9048H232V46L234 46H236H412H413H414L416 46V44.9048H418V43.8095H420V42.7143H422V41.619H423V40.5238H424V39.4286H425V38.3333H426V37.2381H427H427.5H428V36.1429H428.5H429V10.9524H428.5H428V9.85714H427.5H427H426V8.76191H425V7.66667H424V6.57143H423V5.47619H422V4.38095H420V3.28571H418V2.19047H416V1.09524H414V0H413H412H236Z",
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280.242 15.4H284.814C286.374 15.4 287.532 15.766 288.288 16.498C289.044 17.218 289.422 18.34 289.422 19.864V23.536C289.422 25.06 289.044 26.188 288.288 26.92C287.532 27.64 286.374 28 284.814 28H280.242V25.714H281.43V17.668H280.242V15.4ZM284.814 25.732C285.642 25.732 286.218 25.54 286.542 25.156C286.878 24.76 287.046 24.148 287.046 23.32V19.864C287.046 19.144 286.878 18.598 286.542 18.226C286.218 17.854 285.642 17.668 284.814 17.668H283.806V25.732H284.814ZM293.838 24.274C293.85 24.538 293.91 24.784 294.018 25.012C294.138 25.228 294.294 25.42 294.486 25.588C294.69 25.744 294.918 25.87 295.17 25.966C295.434 26.05 295.71 26.092 295.998 26.092C296.562 26.092 296.994 25.996 297.294 25.804C297.594 25.6 297.81 25.36 297.942 25.084L299.886 26.164C299.778 26.392 299.628 26.632 299.436 26.884C299.244 27.124 298.992 27.346 298.68 27.55C298.38 27.754 298.008 27.922 297.564 28.054C297.132 28.186 296.622 28.252 296.034 28.252C295.362 28.252 294.75 28.144 294.198 27.928C293.646 27.712 293.166 27.4 292.758 26.992C292.362 26.584 292.05 26.086 291.822 25.498C291.606 24.91 291.498 24.244 291.498 23.5V23.392C291.498 22.708 291.612 22.084 291.84 21.52C292.08 20.956 292.404 20.476 292.812 20.08C293.22 19.684 293.694 19.378 294.234 19.162C294.786 18.934 295.374 18.82 295.998 18.82C296.766 18.82 297.426 18.958 297.978 19.234C298.53 19.498 298.986 19.84 299.346 20.26C299.706 20.668 299.97 21.124 300.138 21.628C300.306 22.12 300.39 22.6 300.39 23.068V24.274H293.838ZM295.98 20.872C295.404 20.872 294.936 21.022 294.576 21.322C294.216 21.61 293.982 21.946 293.874 22.33H298.086C298.014 21.91 297.786 21.562 297.402 21.286C297.03 21.01 296.556 20.872 295.98 20.872ZM302.807 25.84H305.939V17.56H302.915V15.4H308.207V25.84H311.123V28H302.807V25.84ZM314.045 25.84H317.069V21.232H314.261V19.072H319.337V25.84H321.929V28H314.045V25.84ZM319.895 16.426C319.895 16.666 319.847 16.894 319.751 17.11C319.667 17.314 319.547 17.494 319.391 17.65C319.235 17.794 319.049 17.914 318.833 18.01C318.629 18.094 318.413 18.136 318.185 18.136C317.945 18.136 317.723 18.094 317.519 18.01C317.315 17.914 317.135 17.794 316.979 17.65C316.823 17.494 316.697 17.314 316.601 17.11C316.517 16.894 316.475 16.666 316.475 16.426C316.475 16.186 316.517 15.964 316.601 15.76C316.697 15.544 316.823 15.364 316.979 15.22C317.135 15.064 317.315 14.944 317.519 14.86C317.723 14.764 317.945 14.716 318.185 14.716C318.413 14.716 318.629 14.764 318.833 14.86C319.049 14.944 319.235 15.064 319.391 15.22C319.547 15.364 319.667 15.544 319.751 15.76C319.847 15.964 319.895 16.186 319.895 16.426ZM324.274 19.072H326.722L328.828 26.92H329.152L331.258 19.072H333.706L331.15 28H326.83L324.274 19.072ZM337.923 24.274C337.935 24.538 337.995 24.784 338.103 25.012C338.223 25.228 338.379 25.42 338.571 25.588C338.775 25.744 339.003 25.87 339.255 25.966C339.519 26.05 339.795 26.092 340.083 26.092C340.647 26.092 341.079 25.996 341.379 25.804C341.679 25.6 341.895 25.36 342.027 25.084L343.971 26.164C343.863 26.392 343.713 26.632 343.521 26.884C343.329 27.124 343.077 27.346 342.765 27.55C342.465 27.754 342.093 27.922 341.649 28.054C341.217 28.186 340.707 28.252 340.119 28.252C339.447 28.252 338.835 28.144 338.283 27.928C337.731 27.712 337.251 27.4 336.843 26.992C336.447 26.584 336.135 26.086 335.907 25.498C335.691 24.91 335.583 24.244 335.583 23.5V23.392C335.583 22.708 335.697 22.084 335.925 21.52C336.165 20.956 336.489 20.476 336.897 20.08C337.305 19.684 337.779 19.378 338.319 19.162C338.871 18.934 339.459 18.82 340.083 18.82C340.851 18.82 341.511 18.958 342.063 19.234C342.615 19.498 343.071 19.84 343.431 20.26C343.791 20.668 344.055 21.124 344.223 21.628C344.391 22.12 344.475 22.6 344.475 23.068V24.274H337.923ZM340.065 20.872C339.489 20.872 339.021 21.022 338.661 21.322C338.301 21.61 338.067 21.946 337.959 22.33H342.171C342.099 21.91 341.871 21.562 341.487 21.286C341.115 21.01 340.641 20.872 340.065 20.872ZM346.515 19.072H350.295V20.368H350.619C350.787 19.876 351.069 19.498 351.465 19.234C351.873 18.958 352.359 18.82 352.923 18.82C353.811 18.82 354.525 19.102 355.065 19.666C355.605 20.218 355.875 21.064 355.875 22.204V22.6L353.535 22.816V22.564C353.535 22.072 353.409 21.682 353.157 21.394C352.905 21.094 352.527 20.944 352.023 20.944C351.519 20.944 351.123 21.118 350.835 21.466C350.547 21.814 350.403 22.312 350.403 22.96V25.84H352.455V28H346.299V25.84H348.135V21.232H346.515V19.072ZM364.016 19.072H366.284V30.196C366.284 30.604 366.152 30.94 365.888 31.204C365.636 31.468 365.306 31.6 364.898 31.6H359.588V29.44H363.53C363.854 29.44 364.016 29.26 364.016 28.9V26.704H363.692C363.296 27.736 362.444 28.252 361.136 28.252C360.692 28.252 360.278 28.18 359.894 28.036C359.51 27.892 359.174 27.67 358.886 27.37C358.598 27.07 358.37 26.698 358.202 26.254C358.046 25.798 357.968 25.264 357.968 24.652V19.072H360.236V24.184C360.236 24.82 360.386 25.318 360.686 25.678C360.986 26.026 361.436 26.2 362.036 26.2C362.72 26.2 363.218 25.984 363.53 25.552C363.854 25.108 364.016 24.508 364.016 23.752V19.072Z",
    fill: "#FAFAFA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.68,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.68,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.36,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.36,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.04,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.04,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.72,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.72,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.4,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.4,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.08,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.08,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.76,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.76,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.44,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.44,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.12,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.12,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.8,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.8,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.48,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.48,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.16,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.16,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.84,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.84,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.52,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.52,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.2,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.2,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.88,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.88,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.56,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.56,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.24,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.24,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.92,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.92,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.6,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.6,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.28,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.28,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.96,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.96,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.64,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.64,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.32,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.32,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.68,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.68,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.36,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.36,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.04,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.04,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.72,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.72,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.4,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.4,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.08,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.08,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.76,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.76,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.44,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.44,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.12,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.12,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.8,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.8,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.48,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.48,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.16,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.16,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.84,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.84,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.52,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.52,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.2,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.2,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.88,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.88,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.56,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.56,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.24,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.24,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.92,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.92,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.6,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.6,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.28,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.28,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.96,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.96,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.64,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.64,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.32,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.32,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.84,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.84,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.52,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.52,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.2,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.2,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.88,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.88,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.56,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.56,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.24,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.24,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.92,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.92,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.6,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.6,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.28,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.28,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.96,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.96,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.64,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.64,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.32,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.32,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.68,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.68,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.36,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.36,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.04,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.04,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.72,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.72,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.4,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.4,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.08,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.08,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.76,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.76,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.44,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.44,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.12,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.12,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.8,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.8,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.48,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.48,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.16,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.16,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.84,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.84,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.52,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.52,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.2,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.2,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.88,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.88,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.56,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.56,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.24,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.24,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.92,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.92,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.6,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.6,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.28,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.28,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.96,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.96,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.64,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.64,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.32,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.32,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.68,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.68,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.36,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.36,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.04,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.04,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.72,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.72,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.4,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.4,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.08,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.08,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.76,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.76,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.44,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.44,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.12,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.12,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.8,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.8,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.48,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.48,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.16,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.16,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#087DFD"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.68,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 235.68,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.36,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 239.36,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.04,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 243.04,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.72,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.72,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.4,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 250.4,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.08,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.08,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.76,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.76,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.44,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.44,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.12,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 265.12,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.8,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 268.8,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.48,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 272.48,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.16,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 276.16,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.84,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 279.84,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.52,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 283.52,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.2,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 287.2,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.88,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 290.88,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.56,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 294.56,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.24,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.24,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.92,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 301.92,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.6,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 305.6,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.28,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 309.28,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.96,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 312.96,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.64,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 316.64,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.32,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 320.32,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.68,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 327.68,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.36,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 331.36,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.04,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 335.04,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.72,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 338.72,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.4,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 342.4,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.08,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 346.08,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.76,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 349.76,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.44,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 353.44,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.12,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 357.12,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.8,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 360.8,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.48,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 364.48,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.16,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.16,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.84,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.84,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.52,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.52,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.2,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 379.2,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.88,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 382.88,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.56,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 386.56,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.24,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 390.24,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.92,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 393.92,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.6,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 397.6,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.28,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 401.28,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.96,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 404.96,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.64,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 408.64,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.32,
    y: 40.84,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 412.32,
    y: 44.52,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.84,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 233.84,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.52,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 237.52,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.2,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.2,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.88,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 244.88,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.56,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.56,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.24,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 252.24,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.92,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.92,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.6,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 259.6,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.28,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263.28,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.96,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 266.96,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.64,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 270.64,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.32,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 274.32,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 278,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.68,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.68,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.36,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 285.36,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.04,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.04,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.72,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 292.72,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.4,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 296.4,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.08,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 300.08,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.76,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 303.76,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.44,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 307.44,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.12,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 311.12,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.8,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.8,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.48,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 318.48,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.16,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.16,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.84,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 325.84,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.52,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 329.52,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.2,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.2,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.88,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.88,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.56,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 340.56,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.24,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 344.24,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.92,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 347.92,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.6,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 351.6,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.28,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 355.28,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.96,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 358.96,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.64,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 362.64,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.32,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.32,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 370,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.68,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.68,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.36,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 377.36,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.04,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 381.04,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.72,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 384.72,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.4,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.4,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.08,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 392.08,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.76,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 395.76,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.44,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 399.44,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.12,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 403.12,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.8,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 406.8,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.48,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 410.48,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.16,
    y: 39,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 414.16,
    y: 42.6801,
    width: 1.84,
    height: 1.84,
    fill: "#409BFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_173:31490",
    x: 0.5,
    y: 1.5,
    width: 429,
    height: 45.9796,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.5
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_173:31490"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_173:31490",
    x: 215,
    y: 0,
    width: 218,
    height: 55,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_173:31490"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_173:31490",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeliverySelected);
export default __webpack_public_path__ + "static/media/DeliverySelected.9fb0eba9ee6bf8120506e8e6bdf47910.svg";
export { ForwardRef as ReactComponent };